import { useState } from "react";
import { Link } from "react-router-dom";
import { CalendarDays, ChevronLeft, ChevronRight } from "lucide-react";
import { money } from "../../lib/api";

const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const key = (d) => `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;

export const ShowCalendar = ({ shows, rooms }) => {
  const [month, setMonth] = useState(() => { const d = new Date(); return new Date(d.getFullYear(), d.getMonth(), 1); });
  const [sel, setSel] = useState(() => key(new Date()));
  const byDay = shows.reduce((acc, s) => { const k = key(new Date(s.scheduled_at)); (acc[k] ||= []).push(s); return acc; }, {});
  const first = month.getDay();
  const days = new Date(month.getFullYear(), month.getMonth() + 1, 0).getDate();
  const cells = [...Array(first).fill(null), ...Array.from({ length: days }, (_, i) => new Date(month.getFullYear(), month.getMonth(), i + 1))];
  const today = key(new Date());
  const shift = (n) => setMonth((m) => new Date(m.getFullYear(), m.getMonth() + n, 1));
  const list = byDay[sel] || [];

  return (
    <section className="panel p-5" data-testid="show-calendar">
      <div className="flex items-center gap-2 mb-4">
        <CalendarDays className="h-4 w-4 text-yellow-400" />
        <h2 className="text-lg font-bold">Show calendar</h2>
        <div className="ml-auto flex items-center gap-2">
          <button onClick={() => shift(-1)} data-testid="calendar-prev-btn" className="rounded-[3px] border border-zinc-800 p-1.5 hover:border-yellow-400"><ChevronLeft className="h-4 w-4" /></button>
          <span className="mono text-sm w-36 text-center" data-testid="calendar-month-label">{month.toLocaleDateString(undefined, { month: "long", year: "numeric" })}</span>
          <button onClick={() => shift(1)} data-testid="calendar-next-btn" className="rounded-[3px] border border-zinc-800 p-1.5 hover:border-yellow-400"><ChevronRight className="h-4 w-4" /></button>
        </div>
      </div>
      <div className="grid gap-6 lg:grid-cols-[1fr_300px]">
        <div>
          <div className="grid grid-cols-7 gap-1 mb-1">{DAYS.map((d) => <span key={d} className="mono text-[10px] text-zinc-500 text-center">{d}</span>)}</div>
          <div className="grid grid-cols-7 gap-1">
            {cells.map((d, i) => {
              if (!d) return <span key={`e${i}`} />;
              const k = key(d);
              const n = (byDay[k] || []).length;
              const live = (byDay[k] || []).some((s) => s.status === "live");
              return (
                <button key={k} onClick={() => setSel(k)} data-testid={`calendar-day-${d.getDate()}`}
                  className={`relative h-14 rounded-[3px] border text-left px-1.5 py-1 transition-colors ${sel === k ? "border-yellow-400 bg-yellow-400/10" : "border-[#2d2d38] bg-black/40 hover:border-zinc-500"}`}>
                  <span className={`mono text-xs ${k === today ? "text-yellow-300 font-bold" : "text-zinc-300"}`}>{d.getDate()}</span>
                  {n > 0 && (
                    <span className={`absolute bottom-1 left-1.5 right-1.5 truncate rounded-[2px] px-1 mono text-[9px] ${live ? "bg-pink-500 text-white" : "bg-pink-500/20 text-pink-200"}`}>
                      {n} show{n > 1 ? "s" : ""}
                    </span>
                  )}
                </button>
              );
            })}
          </div>
        </div>
        <div data-testid="calendar-day-shows">
          <p className="mono-label mb-2">{new Date(sel.split("-")[0], sel.split("-")[1], sel.split("-")[2]).toLocaleDateString(undefined, { weekday: "long", month: "short", day: "numeric" })}</p>
          {list.length === 0 && <p className="text-sm text-zinc-500">No shows this day.</p>}
          {list.map((s) => (
            <Link key={s.id} to={`/room/${s.room_id}`} data-testid={`calendar-show-${s.id}`} className="block rounded-[3px] border border-[#2d2d38] p-3 mb-2 hover:border-pink-400 transition-colors">
              <p className="font-semibold truncate">{s.status === "live" && <span className="mr-1.5 text-pink-400">● LIVE</span>}{s.title}</p>
              <p className="mono text-[11px] text-zinc-400">{new Date(s.scheduled_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })} · {rooms[s.room_id] || s.room_id} · {s.host_name}</p>
              <p className="mono text-[11px] mt-1">{s.price > 0 ? <span className="text-yellow-300">{money(s.price)}</span> : <span className="text-zinc-400">Free</span>}
                {s.has_access && s.price > 0 && <span className="ml-2 text-[#39ff6a]">✓ reminder on</span>}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
